<template>
  <footer class="bg-[#0F1117] text-white">

    <!-- Main Footer Grid -->
    <div class="max-w-7xl mx-auto px-6 py-16">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8">

        <!-- ── Brand ────────────────────────────────── -->
        <div>
          <div class="flex items-center gap-3 mb-5">
            <img src="/img/2.png" alt="Kigali Rwanda Car Hire Logo" class="w-10 h-10 object-contain flex-shrink-0" />
            <div>
              <div class="font-bold text-white text-sm leading-tight">Kigali Rwanda Car Hire</div>
              <div class="text-brand-light text-xs">Premium Car Rental</div>
            </div>
          </div>
          <p class="text-white/50 text-sm leading-relaxed mb-6">
            Your trusted partner for car rental in Rwanda. Self-drive, 4x4 safari, and executive vehicles available across Kigali.
          </p>
          <div class="flex items-center gap-3">
            <a href="#" aria-label="Facebook" class="w-9 h-9 bg-white/10 hover:bg-brand rounded-full flex items-center justify-center transition-colors duration-200">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
            <a href="#" aria-label="Instagram" class="w-9 h-9 bg-white/10 hover:bg-brand rounded-full flex items-center justify-center transition-colors duration-200">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z" />
              </svg>
            </a>
            <a :href="whatsappLink" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" class="w-9 h-9 bg-white/10 hover:bg-green-500 rounded-full flex items-center justify-center transition-colors duration-200">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </a>
          </div>
        </div>

        <!-- ── Working Hours ─────────────────────────── -->
        <div>
          <h4 class="text-white font-bold text-xs tracking-widest uppercase mb-6">Working Hours</h4>
          <ul class="space-y-3 text-sm mb-6">
            <li class="flex justify-between items-center">
              <span class="text-white/50">Monday – Friday</span>
              <span class="text-white font-medium">8AM – 6PM</span>
            </li>
            <li class="flex justify-between items-center">
              <span class="text-white/50">Saturday</span>
              <span class="text-green-400 font-medium">WhatsApp Only</span>
            </li>
            <li class="flex justify-between items-center">
              <span class="text-white/50">Sunday</span>
              <span class="text-white font-medium">8AM – 6PM</span>
            </li>
          </ul>
          <div class="p-4 bg-white/5 rounded-xl border border-white/10">
            <div class="flex items-center gap-2 text-green-400 text-xs font-medium">
              <span class="w-2 h-2 bg-green-400 rounded-full animate-pulse flex-shrink-0"></span>
              Available on WhatsApp 24/7
            </div>
          </div>
        </div>

        <!-- ── Contact ───────────────────────────────── -->
        <div>
          <h4 class="text-white font-bold text-xs tracking-widest uppercase mb-6">Contact Us</h4>
          <ul class="space-y-4">
            <li class="flex items-start gap-3">
              <svg class="w-4 h-4 text-brand-light mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clip-rule="evenodd" />
              </svg>
              <span class="text-white/50 text-sm leading-relaxed">Giporoso, Remera<br />Kigali, Rwanda</span>
            </li>
            <li class="flex items-center gap-3">
              <svg class="w-4 h-4 text-brand-light flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              <a href="tel:+250782336854" class="text-white/50 hover:text-brand-light text-sm transition-colors duration-200">+250 782 336 854</a>
            </li>
            <li class="flex items-center gap-3">
              <svg class="w-4 h-4 text-brand-light flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <a href="mailto:info@kigalirwandacarhire.com" class="text-white/50 hover:text-brand-light text-sm transition-colors duration-200 break-all">info@kigalirwandacarhire.com</a>
            </li>
          </ul>
        </div>

        <!-- ── Our Fleet Slideshow ───────────────────── -->
        <div class="sm:col-span-2 lg:col-span-2">
          <h4 class="text-white font-bold text-xs tracking-widest uppercase mb-6">Our Fleet</h4>

          <!-- Image card -->
          <div class="relative rounded-xl overflow-hidden bg-white/5 border border-white/10" style="height: 240px;">
            <div
              v-for="(vehicle, index) in vehicles"
              :key="index"
              class="absolute inset-0 transition-opacity duration-700"
              :class="activeVehicle === index ? 'opacity-100' : 'opacity-0'"
            >
              <img
                :src="vehicle.image"
                :alt="vehicle.name"
                class="w-full h-full object-cover"
                :style="vehicle.portrait ? 'object-position: center 25%' : ''"
              />
              <!-- Gradient overlay + name -->
              <div class="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>
              <div class="absolute bottom-0 left-0 right-0 p-3">
                <p class="text-white text-xs font-semibold">{{ vehicle.name }}</p>
                <p class="text-brand-light text-xs">{{ vehicle.type }}</p>
              </div>
            </div>
          </div>

          <!-- Dots -->
          <div class="flex items-center justify-center gap-1.5 mt-3">
            <button
              v-for="(vehicle, index) in vehicles"
              :key="index"
              @click="activeVehicle = index"
              class="rounded-full transition-all duration-300 bg-white/30 hover:bg-white/60"
              :class="activeVehicle === index ? 'w-5 h-1.5 bg-brand hover:bg-brand' : 'w-1.5 h-1.5'"
            ></button>
          </div>

          <!-- CTA -->
          <router-link
            to="/car-listing"
            class="mt-4 flex items-center justify-center gap-2 w-full bg-brand/10 hover:bg-brand border border-brand/30 hover:border-brand text-brand-light hover:text-white text-xs font-semibold py-2.5 rounded-lg transition-all duration-200"
          >
            View All Vehicles
            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </router-link>
        </div>

      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="border-t border-white/10">
      <div class="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row justify-between items-center gap-2">
        <p class="text-white/35 text-xs">© 2025 Kigali Rwanda Car Hire. All rights reserved.</p>
        <p class="text-white/35 text-xs">
          Designed &amp; built by
          <a href="tel:+250789326245" class="text-brand-light hover:text-white font-semibold transition-colors duration-200">Tamba Group</a>
          <span class="text-white/20 mx-1">·</span>
          <a href="tel:+250789326245" class="hover:text-white/60 transition-colors duration-200">+250 789 326 245</a>
        </p>
      </div>
    </div>

  </footer>
</template>

<script>
export default {
  name: 'FooterItem',
  data () {
    return {
      activeVehicle: 0,
      sliderInterval: null,
      vehicles: [
        { image: 'img/Toyota-rav4-Car-hire-Rwanda.png', name: 'Toyota RAV4', type: 'SUV · Self Drive' },
        { image: 'img/land-cruiser-200-vxr-front.jpeg', name: 'Land Cruiser 200 VXR', type: '4x4 · Safari Ready', portrait: true },
        { image: 'img/nissan-patrol-v8-kigali.jpeg', name: 'Nissan Patrol V8', type: 'Luxury · Premium' },
        { image: 'img/toyota-fortuner-white.jpeg', name: 'Toyota Fortuner', type: 'SUV · Family & Safari' }
      ]
    }
  },
  computed: {
    whatsappLink () {
      const phone = '250782336854'
      const msg = encodeURIComponent('Hello! I\'d like to book a car rental with Kigali Rwanda Car Hire.')
      return `https://wa.me/${phone}?text=${msg}`
    }
  },
  mounted () {
    this.sliderInterval = setInterval(() => {
      this.activeVehicle = (this.activeVehicle + 1) % this.vehicles.length
    }, 3500)
  },
  beforeUnmount () {
    clearInterval(this.sliderInterval)
  }
}
</script>
